import EmptyView2 from '../../layouts/EmptyView2';
import Login from './Login';

export default EmptyView2(Login);
